import { z } from 'zod'

const resourceScopingSchema = z
  .record(
    z.string(),
    z.object({ mode: z.enum(['all', 'specific']), ids: z.array(z.string()) })
  )
  .optional()

export const authorizeSchema = z
  .object({
    idCompany: z.string().min(1, 'Company is required'),
    permissionMode: z.enum(['role', 'custom']).default('role'),
    idRole: z.string().default(''),
    capabilities: z.array(z.object({ permission: z.string() })).default([]),
    resourceScoping: resourceScopingSchema,
  })
  .refine(
    (values) =>
      (values.permissionMode === 'role' && values.idRole.length > 0) ||
      (values.permissionMode === 'custom' && values.capabilities.length > 0),
    {
      message: 'Select a role or at least one capability',
      path: ['idRole'],
    }
  )

export type AuthorizeFormValues = z.input<typeof authorizeSchema>
